export default {"src":"/_next/static/media/zhk-green-sm.896a0f1e.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};